import globalIP from '@/GlobelIP';
import axios from 'axios';
import React from 'react';
import { Col, Drawer, Grid, Row } from 'rsuite';

export default function ImagesSlide({
  close,
  open,
  selectedImages,
  setDragAndDropImages,
  selectClose,
  setIsLoading,
  setRotationDegrees,
  setWidthHeight
}) {
  const removeBg = async urlImage => {
    try {
      setIsLoading(true);
      const imageUrl = `${globalIP}${urlImage}`;
      const imageResponse = await axios.get(imageUrl, { responseType: 'blob' });
      const formData = new FormData();
      formData.append('size', 'auto');
      formData.append('image_file', imageResponse.data, 'image.png');

      const bg = await axios.post('https://api.remove.bg/v1.0/removebg', formData, {
        headers: {
          'X-Api-Key': 'gejH2wrDU6GRh89zwGHsEJba',
          'Content-Type': 'multipart/form-data'
        },
        responseType: 'arraybuffer'
      });
      const processedImageBlob = new Blob([bg.data], { type: 'image/png' });
      const processedImageUrl = URL.createObjectURL(processedImageBlob);
      setDragAndDropImages(prev => [...prev, { images: processedImageUrl }]);
      setRotationDegrees(prev => [...prev, { x: 0, y: 0, z: 0 }]);
      setWidthHeight(prev => [...prev, { width: 300, height: 300 }]);
      selectClose();
      close();
      setIsLoading(false);
    } catch (error) {
      console.error('Error removing background:', error);
    }
  };

  return (
    <Drawer open={open} onClose={close} backdrop="static">
      <Drawer.Header>Images</Drawer.Header>
      <Drawer.Body>
        <Grid fluid style={{ padding: '20px 5px' }}>
          <Row gutter={20}>
            <Col
              xs={8}
              onClick={() => {
                selectClose();
                close();
                setDragAndDropImages(prev => [
                  ...prev,
                  { images: selectedImages?.attributes?.CoverImage?.data?.attributes?.url }
                ]);
                setRotationDegrees(prev => [...prev, { x: 0, y: 0, z: 0 }]);
                setWidthHeight(prev => [...prev, { width: 300, height: 300 }]);
                // removeBg(selectedImages?.attributes?.CoverImage?.data?.attributes?.url);
              }}
            >
              <div style={{ width: '100px', height: '100px', margin: 'auto' }}>
                <img
                  src={`${globalIP}${selectedImages?.attributes?.CoverImage?.data?.attributes?.url}`}
                  alt=""
                  style={{ width: '100%', height: '100%' }}
                />
              </div>
            </Col>
            {selectedImages?.attributes?.MultipleImage?.data &&
              selectedImages?.attributes?.MultipleImage?.data.map(item => {
                return (
                  <Col
                    xs={8}
                    onClick={() => {
                      // removeBg(item.attributes.url);
                      selectClose();
                      close();
                      setDragAndDropImages(prev => [...prev, { images: item.attributes.url }]);
                      setRotationDegrees(prev => [...prev, { x: 0, y: 0, z: 0 }]);
                      setWidthHeight(prev => [...prev, { width: 300, height: 300 }]);
                    }}
                  >
                    <div
                      style={{ width: '100px', height: '100px', margin: 'auto', cursor: 'pointer' }}
                    >
                      <img
                        src={`${globalIP}${item.attributes.url}`}
                        alt=""
                        style={{ width: '100%', height: '100%' }}
                      />
                    </div>
                  </Col>
                );
              })}
          </Row>
        </Grid>
      </Drawer.Body>
    </Drawer>
  );
}
